// extracted by mini-css-extract-plugin
module.exports = {"share":"style-module--share--La4zP","movingPart":"style-module--movingPart--1BU13","shareOptions":"style-module--shareOptions--cpA0w"};